import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DeloitteAiBuildEmailLinkPipe } from "./build-email-link.pipe";

@NgModule({
    declarations: [ DeloitteAiBuildEmailLinkPipe ],
    imports: [ CommonModule ],
    exports: [ DeloitteAiBuildEmailLinkPipe ]
})
export class DeloitteAiEmailModule {}
